import useAuth from 'hooks/useAuth';
import { DEFAULT_PLAN } from 'libs/constants';
import { FunctionComponent, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const REFERRAL_PARAMS = ['ref', 'ref_token'];

const SignUpRedirectPage: FunctionComponent = () => {
  const { isAuthorized } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const URLParams = new URLSearchParams(location.search);
    const plan = URLParams.get('plan') ? URLParams.get('plan') : DEFAULT_PLAN;
    const signUpParams = new URLSearchParams({ plan: String(plan) });
    REFERRAL_PARAMS.forEach((param) => {
      const value = URLParams.get(param);
      value && signUpParams.set(param, value);
    });
    const signUpPath = `/account-sign-up?${signUpParams}`;
    const path = isAuthorized
      ? signUpPath
      : `/check-email?redirect_to=${encodeURIComponent(signUpPath)}`;
    navigate(path, { replace: true });
  }, [location, isAuthorized, navigate]);
  return null;
};

export default SignUpRedirectPage;
